<template>
    <iModal v-model="visible" title="Seek business cooperation" :z-index="1010" @on-cancel="cancel"
        class-name="supply-modal" width="600" :footer-hide="true">
        <div class="supply-modal">
            <Form ref="formInline" style="width:500px;margin:50px auto;" :model="formInline" :label-width="150"
                :rules="ruleInline">
                <FormItem label="Post：" prop="post">
                    <!-- <Select v-model="formInline.typeId">
                        <Option v-for="item in typeList" :value="item.id" :key="item.nameEn">{{ item.nameEn }}</Option>
                    </Select> -->
                    <Select v-model="formInline.post">
                        <Option v-for="item in jobList" :value="item.label" :key="item.label">{{ item.label }}</Option>
                    </Select>
                </FormItem>

                <FormItem prop="info" label="Product demand：">
                    <Input type="text" v-model="formInline.info" placeholder="Product demand" />
                </FormItem>
                <FormItem prop="linkman" label="Contact：">
                    <Input type="text" v-model="formInline.linkman" placeholder="Contact" />
                </FormItem>
                <FormItem prop="phone" label="Mobile number：">
                    <Input type="text" v-model="formInline.phone" placeholder="Mobile number" />
                </FormItem>
                <FormItem prop="email" label="Email：">
                    <Input type="text" v-model="formInline.email" placeholder="Email" />
                </FormItem>
                <div style="text-align:center;padding-top:20px;">
                    <Button style="height:36px;" :loading="loading" type="error"
                        @click="handleSubmit('formInline')">Release demand</Button>
                </div>
            </Form>
        </div>
    </iModal>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
export default {
  name: "supply-modal",
  props: {
    show: {
      type: Boolean,
      default: false
    },
    infoData: {
      type: Object,
      default: () => {}
    },
    infoType: {
      type: String,
      default: ""
    }
  },
  data() {
    const that = this;
    const typeReg = (rule, value, callback) => {
      console.log(value)
      if (!value) {
        callback('请选择类型');
      } else {
        callback();
      }
    };
    const phoneReg = (rule, value, callback) => {
      if (!value) {
        callback('Please enter the mobile number');
      } else if (/^[1][0-9]{10}$/.test(value)) {
        callback();
      } else {
        callback('Please enter the correct mobile number');
      }
    };

    const emailReg = (rule, value, callback) => {
      if (!value) {
          callback('Please enter the email');
      } else if (/^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/.test(value)) {
        callback();
      } else {
          callback('Please enter the correct email');
      }
    };
    return {
        typeList: [],

        jobList: [
            {
                value: "Operation Company or Business Individual",
                label: "Operation Company or Business Individual"
            },
            {
                value: "E-Commerce Enterprise/Individual Buyer/Retail",
                label: "E-Commerce Enterprise/Individual Buyer/Retail"
            },
            {
                value: "Pharmacy, retail, supermarket, department store",
                label: "Pharmacy, retail, supermarket, department store"
            },
            {
                value: "physical examination institution / Healthcare Service",
                label: "physical examination institution / Healthcare Service"
            },
            {
                value: "Civil administration / Disabled Persons' Federation/Rehabilitation/Rest home/Social welfare institutions/System integrators/Medical informatization",
                label: "Civil administration / Disabled Persons' Federation/Rehabilitation/Rest home/Social welfare institutions/System integrators/Medical informatization"
            },
            {
                value: "Manufacturing Company",
                label: "Manufacturing Company"
            },
            {
                value: "Medical Device Design and Manufacturing Company/electronic components/Packaging equipment",
                label: "Medical Device Design and Manufacturing Company/electronic components/Packaging equipment"
            },
            {
                value: "Scientific research institutions / Investment and financing institutions",
                label: "Scientific research institutions / Investment and financing institutions"
            },
            {
                value: "Institute / EPC",
                label: "Institute / EPC"
            }
        ],

        
      visible: false,
      loading: false,
      formInline: {
        typeId: "",
          post: "",
        info: "",
        linkman: "",
        phone: "",
          email: "",
      },
      ruleInline: {
          post: [{ required: true, message: "Please enter the post", trigger: "blur" }],
        info: [{ required: true, message: "Please enter the supply and demand", trigger: "blur" }],
        linkman: [{ required: true, message: "Please enter the person to contact", trigger: "blur" }],
        type: [{ required: true, validator: typeReg, trigger: "change" }],
        // phone: [{ required: true, validator: phoneReg, trigger: "blur" }],

          email: [{ required: true, validator: emailReg, trigger: "change" }],
      },
    };
  },
  computed: {
    ...mapGetters({
      user: "getUser",
      exhibition: "loginModule/getExhibition"
    }),
  },
  watch: {
    show(val, oldVal) {
      this.visible = val;
      if (val) {
        this.init();
      }
    }
  },
  methods: {
    ...mapActions({
      getRelease: "hall/getRelease",
      sendRelease: "hall/sendRelease",
      postCallingadd: "hall/postCallingadd"
    }),
    async init() {
      let typeList = await this.getRelease(this.exhibition.id);
      this.typeList = typeList;
    },
    async handleSubmit(name) {
      let valid = await this.validForm(name);
        if (!valid) return;

        // if (!this.formInline.typeId) {
        //     this.$Message.warning("Please select the type of release");
        //     return;
        // }
      
        this.loading = true;
      setTimeout(() => {
          this.loading = false;
      }, 3000);
    //   var req = {
    //     AgentId: this.exhibition.agentId,
    //     ExhibitionId: this.exhibition.id,
    //     TypeId: this.formInline.typeId,
    //     FromType: 1, // 《0：企业，1：用户》(小程序端只有用户)
    //     FromId: this.user.userId,
    //     Information: this.formInline.info,
    //     SourceType: this.infoType,
    //   };
    //   if (this.infoType === "展商") {
    //     req.SourceId = this.infoData.compId;
    //     req.SourceName = this.infoData.name;
    //   } else if (this.infoType === "展品") {
    //     req.SourceId = this.infoData.id;
    //     req.SourceName = this.infoData.name;
    //   } else if (this.infoType === "供需") {
    //     req.SourceId = this.infoData.id;
    //     req.SourceName = this.infoData.information;
    //     }
        console.log(this.infoData,'5464654564');
        let body = {
            Sender: this.user.userId,
            CardInfoData: {
                CompanyName: '',
                LinkMan: this.formInline.linkman,
                Mob: this.formInline.phone,
                Title: this.formInline.post,
                Email: this.formInline.email,
                HeadPortrait: '',
            },
            SourceType: 2,//数据类型1 展商，2 展品，3供需,
            SourceId: this.infoData.id,//来源id
            SourceName: this.infoData.name,//数据来源名称
            SourceLinkType: 2,
            TalkType: '采购',//采购类别

            TalkContent: this.formInline.info, //咨询详情
            ExhibitionId: this.exhibition.id, //展会id
            identityType: this.formInline.post,//您的身份
            isdeal: false
        }


        let result = await this.postCallingadd(body);
      if (result.successed) {
        this.loading = false;
        this.$Message.success("success!");
        this.cancel();
      } else {
        this.loading = false;
        this.$Message.error("fail,please try again!");
      }
    },
    validForm(name) {
      // 验证表单
      return new Promise((resolve, reject) => {
        this.$refs[name].validate(valid => {
          resolve(valid);
        });
      });
    },
    cancel() {
      this.$refs["formInline"].resetFields();
      this.formInline = {
        typeId: "",
        info: "",
        linkman: "",
        phone: "",
      }
      this.$emit("close");
    }
  },
  created() {
    this.$i18n.locale = "en";
  }
};
</script>

<style lang="scss">
.supply-modal {
  display: flex;
  align-items: center;
  justify-content: center;
  .ivu-modal{
    top: 0;
  }
  .ivu-modal-body {
    padding: 0;
  }
}
</style>